"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateOverrideComparisonOperators = exports.RateOverrideComparisonOperator = void 0;
var RateOverrideComparisonOperator;
(function (RateOverrideComparisonOperator) {
    RateOverrideComparisonOperator["Equal"] = "equal";
    RateOverrideComparisonOperator["LessThan"] = "lessThan";
    RateOverrideComparisonOperator["GreaterThan"] = "greaterThan";
    RateOverrideComparisonOperator["NotEqual"] = "notEqual";
    RateOverrideComparisonOperator["Contains"] = "contains";
})(RateOverrideComparisonOperator = exports.RateOverrideComparisonOperator || (exports.RateOverrideComparisonOperator = {}));
exports.RateOverrideComparisonOperators = Object.values(RateOverrideComparisonOperator);
//# sourceMappingURL=rate-override-comparison-operator.js.map